//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Price from '@motionelements/core/src/components/product/ElementPrice.vue';
import Duration from '@motionelements/core/src/components/product-card/sections/info/items/ProductInfoItemDuration.vue';
import Tempo from '@motionelements/core/src/components/product-card/sections/info/items/ProductInfoItemTempo.vue';
import Loop from '@motionelements/core/src/components/product-card/sections/info/items/ProductInfoItemLoop.vue';

export default {
  name: 'product-card-audio-info-full',
  components: {
    Price,
    Duration,
    Tempo,
    Loop,
  },
  props: {
    element: Object,
    isSearchRepo: Boolean,

    details: Object,
    showPrice: {
      type: Boolean,
      default: true,
    },
    showCategory: {
      type: Boolean,
      default: false,
    },
    showTempo: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    mediaType() {
      return _.get(this.element, 'mediaType', _.get(this.element, 'media_type'));
    },
    isMusic() {
      return this.mediaType === 'music';
    },
    // isSubscription() {
    //   return _.get(this.element, 'subscription');
    // },
    isPro() {
      return _.get(this.element, 'usageRights.pro') === true;
    },
    shortProLabel() {
      // use P.R.O. if translation is longer than 6 chars
      const label = this.$i18n.t('product.pro');
      return label.length > 6 ? 'P.R.O.' : label;
    },
    searchBaseUrl() {
      return `/search/${this.mediaType.replace('_', '-')}`;
    },
    displayGenres() {
      let category;

      if (this.$route.query.genre) {
        category = this.element.categories.find(x => x.id === this.$route.query.genre);
        if (category) {
          return [category];
        }
      }

      category = this.element.categories.find(x => x.type === 'genre');

      return category ? [category] : [];
    },
    displayCategories() {
      let category;

      if (this.$route.query.category) {
        category = this.element.categories.find(x => x.id === this.$route.query.category);
        if (category) {
          return [category];
        }
      }

      category = this.element.categories.find(x => x.type === 'category');

      return category ? [category] : [];
    },
  },
  methods: {
    viewCategory(event) {
      // if (process.env.VUE_APP_ENV !== 'production' && isSearchRepo) {
      if (this.isSearchRepo) {
        // open new window: windows use ctrl key, mac use command=meta key
        // change use preventDefault to provide open tab in background function
        // if (window.event.ctrlKey || window.event.metaKey) {
        //   console.log('control key event');
        //   // window.open(this.$link(this.element.html.url).url());
        //   return;
        // }
        event.preventDefault();
        this.$router.push({
          path: this.$link(event.target.href).fullPath(),
        });
        // return false;
      }

      // window.location.href = this.element.html.url;
    },
  },
};
